module.exports = __webpack_public_path__ + "static/media/sunCreme (3).37b8f4c0.jpg";